exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mobile-breadcrumb-nav{font-size:16px;font-weight:700;margin-bottom:20px;margin-left:20px}", ""]);

// exports
